// extracted by mini-css-extract-plugin
export default {"calendarEventTooltip":"calendarEventContent_calendarEventTooltip__KXtG5"};